import { clearAllRetained } from "./retainedAttempt";

/**
 * Retained create attempts (which can hold generated passwords) belong to the
 * user who made them. Idempotency keys are scoped per user on the server, so
 * they survive a same-user re-login; they are dropped when the session ends
 * or another user signs in.
 */
export function watchRetainedOwner(
  currentUserId: () => string | null,
  subscribe: (listener: () => void) => () => void,
  clear: () => void = clearAllRetained,
): () => void {
  let owner = currentUserId();
  return subscribe(() => {
    const userId = currentUserId();
    if (userId === owner) return;
    if (owner !== null) clear();
    owner = userId;
  });
}
